export class Achievements {
    id : number;
    achievementCode : string;
    achievementName : string;
    displayOrder : number;
}